import React from 'react'
import ChildListTable from './ChildListTable'
import { Link } from 'react-router-dom'
import routes from '../../routes'
import {faPlusCircle} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import { get } from 'lodash'
import { useLocation } from 'react-router-dom'
import {itemType} from '../../types'
import PropTypes from 'prop-types'

/**
 * Child Items section with heading and table
 * @param item
 * @param queryVariables
 * @returns JSX content for the Child Items section
 */
function ItemChildren({ item, queryVariables }) {
  const location = useLocation()
  const childItems = get(item, 'childItems', {})
  const itemId = item.id
  const canWrite = item.permissions.currentUser.canWrite

  return (
    <div>
      <h2 className="sb-section-header">Child Items
        { canWrite ?
          <Link to={`${routes.itemPath}/${itemId}/new`}><FontAwesomeIcon icon={faPlusCircle} fixedWidth /></Link>
          : ''
        }
      </h2>
      <ChildListTable
        location={ location }
        childItems={ childItems }
        queryVariables={ queryVariables }
      />
    </div>
  )
}

ItemChildren.propTypes = {
  item: itemType,
  queryVariables: PropTypes.any
}



export default ItemChildren


